module.exports = __webpack_public_path__ + "media/images/pages/careers-support/mikaela-90bf3fe92c738961dc77810c54848e0c.png";